var swiper = new Swiper(".featured-product-slider", {
    slidesPerView: 4,
    spaceBetween: 15,
    breakpoints: {
        0: {
            slidesPerView: 1.2,
            spaceBetween: 15,
        },
        480: {
            slidesPerView: 2.5,
            spaceBetween: 15,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 15,
        },
        992: {
            slidesPerView: 3.5,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 15,
        },
    },
});

var swiper = new Swiper(".new-deals-swiper", {
    slidesPerView: 3,
    spaceBetween: 10, 
    breakpoints: {
        0: {
            slidesPerView: 1.2,
            spaceBetween: 10
        },
        480: {
            slidesPerView: 2.5,
            spaceBetween: 10
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 10
        },
        1040: {
            slidesPerView: 3,
            spaceBetween: 10
        },
    },
});

var swiper = new Swiper(".services-swiper ", {
    slidesPerView: 3,
    spaceBetween: 50, 
    breakpoints: {
        0: {
            slidesPerView: 1.2,
            spaceBetween: 10
        },
        580: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        768: {
            slidesPerView:2.5,
            spaceBetween: 20
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30
        },
    },
});

var swiper = new Swiper(".popular-product-slider", {
    slidesPerView: 4,
    spaceBetween: 15,
    breakpoints: {
        0: {
            slidesPerView: 1.2,
            spaceBetween: 15,
        },
        480: {
            slidesPerView: 2.5,
            spaceBetween: 15,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 15,
        },
        992: {
            slidesPerView: 3.5,
            spaceBetween: 15,
        },
        1040: {
            slidesPerView: 4,
            spaceBetween: 15,
        },
    },
});
var swiper = new Swiper(".product-offer-badge", {
    slidesPerView: 2,
    spaceBetween: 10,
    breakpoints: {
        0: {
            slidesPerView: 1.5,
            spaceBetween: 15,
        },
        580: {
            slidesPerView: 2.5,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 10,
        },
        990: {
            slidesPerView: 1.5,
            spaceBetween: 10,
        },
        1199: {
            slidesPerView:2.2,
            spaceBetween: 10,
        },
    },
});


// header__search
document.addEventListener("DOMContentLoaded", function () {

    const openBtn = document.querySelector(".search-toggle");
    const closeBtn = document.querySelector(".search-modal__close-button");
    const modal = document.querySelector(".search-modal");
    const overlay = document.querySelector(".search-overlay");

    if (!openBtn || !closeBtn || !modal || !overlay) return;

    // OPEN
    function openSearch() {
        modal.classList.add("active");
        overlay.classList.add("active");
        document.body.classList.add("no-scroll");
    }

    // CLOSE
    function closeSearch() {
        modal.classList.remove("active");
        overlay.classList.remove("active");
        document.body.classList.remove("no-scroll");
    }

    // CLICK EVENTS
    openBtn.addEventListener("click", openSearch);
    closeBtn.addEventListener("click", closeSearch);
    overlay.addEventListener("click", closeSearch);

    // CLICK OUTSIDE (extra safety)
    document.addEventListener("click", function (e) {
        if (!modal.contains(e.target) && !openBtn.contains(e.target)) {
            closeSearch();
        }
    });

    // ESC KEY CLOSE
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeSearch();
    });

});
// header__search


// product-empty-recommendation
// var swiper = new Swiper(".product-empty-recommendation", {
//     slidesPerView: 2,
//     spaceBetween: 10,
//     breakpoints: {
//         0: {
//             slidesPerView: 1.5,
//             spaceBetween: 15,
//         },
//         580: {
//             slidesPerView: 2.5,
//             spaceBetween: 10,
//         },
//         768: {
//             slidesPerView: 2.5,
//             spaceBetween: 10,
//         },
//         990: {
//             slidesPerView: 1.5,
//             spaceBetween: 10,
//         },
//         1199: {
//             slidesPerView:2.2,
//             spaceBetween: 10,
//         },
//     },
// });
// product-empty-recommendation

// // recommendations cart drawer
// document.addEventListener("DOMContentLoaded", () => {
//   loadRecommendations();
// });

// function loadRecommendations() {
//   const container = document.querySelector(".recommendations-container");
//   if (!container) return;

//   const productId = container.dataset.productId;

//   fetch(`/recommendations/products.json?product_id=${productId}&limit=8`)
//     .then(res => res.json())
//     .then(data => {
//       if (data.products.length > 0) {

//         container.innerHTML = data.products.map(product => `
//           <div class="swiper-slide">
//             <div class="recommendation-item-box">
//               <a href="${product.url}">&nbsp</a>
//               <div class="media media--transparent media--portrait media--hover-effect" style="padding-bottom: 130%;">
//                 <img src="${product.images[0]}" alt="${product.title}" />
//               </div>
//                 <div class="card-information">
//                   <div class="card-information__wrapper">
//                     <div class="recommendation_card_title card__title">
//                       <h5>${product.title}</h5>
//                     </div>
//                     <span class="price">
//                         ${(product.price/100).toLocaleString('en-IN',{style:'currency',currency:'INR'})}
//                     </span>
//                   </div>
//                 </div>
              
//             </div>
//           </div>
//         `).join('');
//         initSwiper();
//       }
//     });
// }

// function initSwiper() {
//   const existingSwiper = document.querySelector(".recommendation-slider")?.swiper;

//   // Destroy if already initialized (important for cart updates)
//   if (existingSwiper) {
//     existingSwiper.destroy(true, true);
//   }

//   new Swiper(".recommendation-slider", {
//     slidesPerView: 2,
//     spaceBetween: 10,
//     mousewheelControl: true,
//     loop: false,
//     breakpoints: {
//       768: {
//         slidesPerView: 3,
//       },
//     }
//   });
// }
// // recommendations cart drawer


// ============================================================
// CART DRAWER RECOMMENDATIONS
// ============================================================

let recSwiper = null;
let emptyRecSwiper = null;

function initFilledSwiper() {
  if (recSwiper) { recSwiper.destroy(true, true); recSwiper = null; }
  const el = document.querySelector(".recommendation-slider");
  if (!el) return;
  recSwiper = new Swiper(".recommendation-slider", {
    slidesPerView: 2,
    spaceBetween: 10,
    loop: false,
  });
}

function initEmptySwiper() {
  if (emptyRecSwiper) { emptyRecSwiper.destroy(true, true); emptyRecSwiper = null; }
  const el = document.querySelector(".product-empty-recommendation");
  if (!el) return;
  emptyRecSwiper = new Swiper(".product-empty-recommendation", {
    slidesPerView: 2,
    spaceBetween: 10,
  });
}

function loadRecommendations() {
  const container = document.querySelector(".recommendations-container");
  if (!container) return;

  const productId = container.dataset.productId;
  if (!productId) return;

  // Avoid re-fetching for same product
  if (container.dataset.loaded === productId) {
    initFilledSwiper();
    return;
  }

  fetch(`/recommendations/products.json?product_id=${productId}&limit=8`)
    .then(res => res.json())
    .then(data => {
      if (!data.products || data.products.length === 0) return;
      container.dataset.loaded = productId;
      container.innerHTML = data.products.map(product => `
        <div class="swiper-slide">
          <div class="recommendation-item-box">
            <a href="${product.url}">&nbsp;</a>
            <div class="media media--transparent media--portrait media--hover-effect" style="padding-bottom: 130%;">
              <img src="${product.images[0]}" alt="${product.title}" loading="lazy" />
            </div>
            <div class="card-information">
              <div class="card-information__wrapper">
                <div class="recommendation_card_title card__title">
                  <h5>${product.title}</h5>
                </div>
                <span class="price">
                  ${(product.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' })}
                </span>
              </div>
            </div>
          </div>
        </div>
      `).join('');
      initFilledSwiper();
    })
    .catch(err => console.error("Recommendations fetch error:", err));
}

function handleRecommendations() {
  const filledContainer = document.querySelector(".recommendations-container");
  const emptyContainer  = document.querySelector(".product-empty-recommendation");

  if (filledContainer) {
    loadRecommendations();
  } else if (emptyContainer) {
    initEmptySwiper();
  }
}

document.addEventListener("DOMContentLoaded", handleRecommendations);

document.addEventListener("DOMContentLoaded", () => {
  const cartDrawerEl = document.querySelector("cart-drawer");
  if (!cartDrawerEl) return;


  customElements.whenDefined("cart-drawer").then(() => {
    const proto = Object.getPrototypeOf(cartDrawerEl);
    const originalRenderContents = proto.renderContents;

    proto.renderContents = function(parsedState) {
      originalRenderContents.call(this, parsedState);
      setTimeout(handleRecommendations, 100);
    };
  });
});

// Item REMOVED or quantity changed ─────────────────
// CartDrawerItems.updateQuantity() replaces .drawer__inner innerHTML.
// It ends with publish(PUB_SUB_EVENTS.cartUpdate) — we subscribe to that.
document.addEventListener("DOMContentLoaded", () => {
  customElements.whenDefined("cart-drawer-items").then(() => {
    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(handleRecommendations, 100);
      });
    }
  });
});

document.getElementById('share-product-btn') && document.getElementById('share-product-btn').addEventListener('click', async () => {
  const shareData = {
    title: document.title,
    text: 'Check out this product!',
    url: window.location.href
  };

  if (navigator.share) {
    try {
      await navigator.share(shareData);
    } catch (err) {
      console.log('Error sharing:', err);
    }
  } else {
    alert('Sharing not supported on this browser');
  }
});